import { makeStyles } from '@material-ui/core'

import { getFont, lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  accommodationRow: {
    display: 'grid',
    gridTemplateColumns: '5.42fr repeat(14,1fr)',
    height: 67,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[300]
  },
  accommodationRowRowForMonth: {
    gridTemplateColumns: '9fr repeat(31,1fr)',
    [theme.breakpoints.down(1460)]: {
      gridTemplateColumns: '10fr repeat(31,1fr)'
    }
  },
  accommodationContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  accommodationIcon: {
    marginLeft: 3
  },
  accommodationName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  numberOfRoomType: {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  roomTypeLoading: {
    width: 14,
    marginRight: 6,
    marginLeft: 4,
    marginTop: 4
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  channelArrowRight: {
    marginRight: 6,
    fontSize: 14,
    transition: `transform 0.2s`,
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`,
    cursor: 'pointer'
  },
  channelArrowRightCollapsed: {
    transform: `rotate(${lang === 'fa' ? '-90deg' : '90deg'})`
  },
  dayContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: 'gray',
    'box-sizing': 'border-box',
    height: '100%',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`,
    '& input': {
      fontSize: 12,
      width: '98%',
      textAlign: 'center',
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: theme.palette.type === 'dark' ? 'white' : 'black',
      fontFamily: getFont()
    }
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  },
  selectedDayContainer: {
    border: `2px solid ${theme.palette.grey[700]}`,
    borderRadius: 4
  },
  status: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  normalStatus: {
    background: theme.palette.success.main
  },
  warningStatus: {
    background: theme.palette.warning.main
  },
  criticalStatus: {
    background: theme.palette.error.main
  },
  unexpectedStatus: {
    background: theme.palette.info.main
  },
  textTimeTwoWeeks: {
    fontSize: 12,
    color: theme.palette.primary.contrastText
  },
  textTimeMonth: {
    fontSize: 9,
    color: theme.palette.primary.contrastText
  }
}))
export default useStyles
